export function getInventoryReportT() {
    return new Promise((resolve, reject) => {
        fetch("https://www.jpadel-cms.com/api/locations/getInventoryReport", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "authorization": window.localStorage.getItem('token'),
                },
            })
            .then((res) => {
                resolve(res.json());
            })
            .catch((err) => reject(err));
    });
}


export function getInventoryReportWDate(data) {
    return new Promise((resolve, reject) => {
        fetch("https://www.jpadel-cms.com/api/locations/getInventoryReportWDate", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "authorization": window.localStorage.getItem('token'),
                },
             body: JSON.stringify(data),
            })
            .then((res) => {
                resolve(res.json());
            })
            .catch((err) => reject(err));
    });
}

